export default {
  pt: {
    title: "Você já cumpriu essa etapa",
    description1: "Toque em continuar para prosseguir com a contratação do seu seguro.",
  },
  en: {
    title: "You have already completed this step",
    description1: "Tap continue to keep going with your insurance contract.",
  },
};
